export const user_action_types = {
	SET_USER: "SET_USER",
	GET_USER: "GET_USER",
	GET_USER_SUCCESS: "GET_USER_SUCCESS",
	GET_USER_FAILURE: "GET_USER_FAILURE",
	CLEAR_ERRORS: "CLEAR_ERRORS",
};

export const products_action_types = {
	GET_PRODUCTS: "GET_PRODUCTS",
	GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
	GET_PRODUCTS_FAILURE: "GET_PRODUCTS_FAILURE",
	SET_CURRENT_PRODUCT: "SET_CURRENT_PRODUCT",
};

export const cart_action_types = {
	ADD_PRODUCT_TO_CART: "ADD_PRODUCT_TO_CART",
	REMOVE_PRODUCT_FROM_CART: "REMOVE_PRODUCT_FROM_CART",
	UPDATE_PRODUCT_AMOUNT: "UPDATE_PRODUCT_AMOUNT",
	POST_PRODUCT_TO_CART_SUCCESS: "POST_PRODUCT_TO_CART_SUCCESS",
	POST_PRODUCT_TO_CART_FAILURE: "POST_PRODUCT_TO_CART_FAILURE",
	GET_ALL_CATRS: "GET_ALL_CATRS",
	GET_ALL_CATRS_SUCCESS: "GET_ALL_CATRS_SUCCESS",
	GET_ALL_CATRS_FAILURE: "GET_ALL_CATRS_FAILURE",
	CLEAR_ALL_CATRS: "CLEAR_ALL_CATRS",
};
